<template>
  <transition name="message-animation">
    <div class="message" :class="`type-${messageType}`" v-show="show">
        <p class="message__text" v-html="message"></p>
        <p class="close">
          <button class="button button--text button--inline"type="button" @click.prevent="show = false">
            <i class="fa fa-times ml-10" aria-hidden="true"></i>
            <span class="visuallyhidden">Close</span>
          </button>
        </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Message',

  data() {
    return {
      message: '',
      messageType: 'info',
      show: false,
    };
  },

  created() {
    window.photoClaim.$on('message', payload => {
      // message component payload is an Array
      // Example: ['messageType', 'message text']

      this.messageType = payload[0];
      this.message = payload[1];
      window.photoClaim.errors.push(payload[1]);
      this.show = true;
      window.photoClaim.messageCurrentlyVisible = true;
    });
  },

  updated() {
    window.photoClaim.$on('dismissMessage', () => {
      this.show = false;
      window.photoClaim.messageCurrentlyVisible = false;
    });
  },
};
</script>

<style scoped lang="scss">

.message {
  background: white;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
  padding: 10px;
  position: fixed;
  display: flex;
  justify-content: space-between;
  top: 0;
  width: 100%;
  z-index: 300;
}

.type-error {
  color: var(--color-error);
  display: flex;
  justify-content: space-between;
}

.message__text {
  display: inline-block;

  .type-error & {
    color: var(--color-error);
  }
}

.type-success {
  color: var(--color-success);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.message__text {
  display: inline-block;

  .type-success & {
    color: var(--color-success);
  }
}

.type-inverse {
  background-color: black;
  color: white;

  p,
  h3,
  .close a {
    color: white !important;
  }
}

.message__type-label {
  display: inline-block;
  font-weight: bold;
}

/* Custom Animation */
.message-animation-enter {
  opacity: 0;
  transform: translateY(20px);
}

.message-animation-enter-active {
  transition: all 200ms ease-in;
}

.message-animation-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.message-animation-leave {
  opacity: 1;
}

.message-animation-leave-active {
  transition: all 200ms ease-out;
}

.message-animation-leave-to {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/global/Message.vue